import { render, staticRenderFns } from "./rJiezhenZhong_list.vue?vue&type=template&id=6197e8e3&scoped=true&"
import script from "./rJiezhenZhong_list.vue?vue&type=script&lang=js&"
export * from "./rJiezhenZhong_list.vue?vue&type=script&lang=js&"
import style0 from "./rJiezhenZhong_list.vue?vue&type=style&index=0&id=6197e8e3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6197e8e3",
  null
  
)

export default component.exports